import React, {useEffect, useState} from 'react';
import queryString from 'query-string';
import {agent_promo_update, agent_promo_add, agent_promo} from '../../../service/promo'
import {agents as getAgents, agent_permission_lookup} from '../../../service/agents';
import '../links_add/style.css';
import YMDPicker from '../../../components/ymd_picker'
import { getCookie } from '../../../utils/shared';

const OfferAdd = ({user_token, set_menu, authorize}) => {
    const [promo_d, setPromoD] = useState(null);
    
    const [promo_code, setCode] = useState("");
    const [promo_type, setPromoType] = useState(0);
    const [expire, setExpire] = useState(null);
    const [minimum_cost, setMinCost] = useState(null);
    const [amount, setAmount] = useState(0);
    const [cookie_verification, setCookieVerification] = useState(null);
    const [number_of_uses, setNumberOfUses] = useState(null);
    const [departure_from, setDepartureFrom] = useState(null);
    const [departure_to, setDepartureTo] = useState(null);
    const [agents, setAgentOptions] = useState([]);

    const [btnLbl, setBtnLbl] = useState("Add");


    let uli_tk = getCookie('agt_usign',true);
    const agent_id = uli_tk["user_id"];

    const [selected_agent, setSelectedAgent] = useState(agent_id);

    const change_agent = (agent_id) => {
		if(agent_id == -1){
			setSelectedAgent(null);
			return
		}
		setSelectedAgent(Number(agent_id));
	}

    useEffect(() => {
        
        const ini = async() => {

                const xx = await agent_permission_lookup(user_token, 3)
                if(!xx.result)
                {
                    window.location = "/"
                }
            

                //authorize(1);

                let uli_tk = getCookie('agt_usign',true);
                let x = queryString.parse(document.location.search);

                const lnks = [{'url': '/', 'name': 'Home'}, {'url': '/promos', 'name': 'Promotional Codes'}]
                set_menu(lnks)

                let fa = 'id first_name second_name email_address';
                getAgents(user_token, fa, []).then((r) => {

                    const aops = [];			
                    for(const x of r.agents.result){

                        aops.push({"first_name": x.first_name, "second_name":  x.second_name, "id": x.id, "email_address": x.email_address})

                    }
                    setAgentOptions(aops)
                });

                if(x.pid == null){
                    return
                }
                
                setBtnLbl("Update")


                let f = "id code verification_cookie expires amount type minimum_cost departure_from departure_to number_of_uses";

                agent_promo(Number(x.pid),f, user_token).then((r) =>{

                    if(r == null){
                        return
                    }
                    if(r.errors != null){
                        if(r.errors.length > 0){
                            alert(r.errors[0].message)
                            return
                        }
                        alert("Unexpected Error Contact HWT support...")
                        return
                    }
                    if(r.agent_promotional_code.error != null){
                        alert(r.promotional_codes.error.message)
                        return
                    }	

                    if(r.agent_promotional_code.result == null){
                        return
                    }

                    setPromoD(r.agent_promotional_code.result);
                    setCode(r.agent_promotional_code.result.code);
                    setPromoType(r.agent_promotional_code.result.type);
                    setExpire(r.agent_promotional_code.result.expires);
                    setAmount(r.agent_promotional_code.result.amount);
                    setMinCost(r.agent_promotional_code.result.minimum_cost);
                    setCookieVerification(r.agent_promotional_code.result.verification_cookie);
                    setNumberOfUses(r.agent_promotional_code.result.number_of_uses);
                    setDepartureFrom(r.agent_promotional_code.result.departure_from);
                    setDepartureTo(r.agent_promotional_code.result.departure_to);
                    
                
                });
        }



        ini();


    }, [])

    const change_expire = (value) => {
        setExpire(value);
    }

    const change_dep_from = (value) => {
        setDepartureFrom(value);
    }

    const change_dep_to = (value) => {
        setDepartureTo(value);
    }

    const addupdate_discount = async () => {

        if(promo_code == null){
            alert("Code required")
            return;
        }
        if(expire == null){
            alert("Expire date required")
            return;
        }

        let str_dep = "";
        let str_to = "";
        if(departure_from != null && departure_to != null){
            str_dep = departure_from;
            str_to = departure_to;
        }

        let min_cost = -1;
        if(minimum_cost != null){
            min_cost = minimum_cost;
        }

        let num_of_use = -1;
        if(number_of_uses != null){
            num_of_use = number_of_uses;
        }

        let verification_cookie = cookie_verification;
        if(cookie_verification == null){
            verification_cookie = "";
        }
        //make graph all and add this sucker
        if(promo_d == null){
            let new_discount = await agent_promo_add(selected_agent, promo_code, verification_cookie, expire, amount, promo_type, str_dep, str_to, min_cost, num_of_use, "id", user_token)
            if(new_discount == null){
                alert("Failed to add promotional code. Contact HWT support");
                return
            }
        }
        else{
      
            let new_discount = await agent_promo_update(selected_agent, promo_d.id, promo_code, verification_cookie, expire, amount, promo_type, str_dep, str_to, min_cost, num_of_use, "id", user_token)
            if(new_discount == null){
                alert("Failed to update promotional code. Contact HWT support");
                return
            }
        }
  
        
        window.location.replace("/promos");

    }



    let filter_agt_ops = null;
	if(agents.length > 0){
		const str_filt_ops = [];

        if(agents.length > 1){
            if(selected_agent == null){
                str_filt_ops.push(<option selected={true} value={-1}>Anyone</option>)
            }
            else{
                str_filt_ops.push(<option value={-1}>Anyone</option>)
            }
        }



		for(const x of agents){
			let sel = false;
			if(x.id == selected_agent){
				sel = true;
			}
			str_filt_ops.push(<option selected={sel} value={x.id}>{x.first_name} {x.second_name}</option>)
		}

		filter_agt_ops = <select onChange={(e) => change_agent(e.target.value) }>{str_filt_ops}</select>

	}

    let type_ops = [{"value": 0, "text": "Monetary (£)"}, {"value": 1, "text": "Percentage (%)"}]
    let type_ops_x = [];
    for(let x of type_ops){
        if(promo_type == x.value){
            type_ops_x.push(<option selected={true} value={x.value}>{x.text}</option>);
        }
        else{
            type_ops_x.push(<option value={x.value}>{x.text}</option>);
        }
    }  

    let pAgentSec = <div className='input_section'>
          <div className='input_label_section'>
            <label>Agent</label>
        </div>
        <div className='input_field_section'>
            {filter_agt_ops}
        </div>
    </div>


    let codeSec = <div className='input_section'>
        <div className='input_label_section'>
            <label>Code</label>
        </div>
        <div className='input_field_section'>
            <input id='txt_code' onChange={(d) => setCode(d.target.value)} value={promo_code}></input>
        </div>
    </div>

    let pTypeSec = <div className='input_section'>
          <div className='input_label_section'>
            <label>Promotional Code Type</label>
        </div>
        <div className='input_field_section'>
            <select id='ddl_type' onChange={(d) => setPromoType(d.target.value)}>
                {type_ops_x}
            </select>
        </div>
    </div>

    let amt = <div className='input_section'>
    <div className='input_label_section'>
        <label>Amount</label>
    </div>
    <div className='input_field_section medium'>
        <input id='txt_amount' onChange={(d) => setAmount(d.target.value)} type='number' value={amount}></input>
    </div>
    </div>   
     
    let minCostSec = <div className='input_section'>
    <div className='input_label_section'>
        <label>Minimum Cost</label>
    </div>
    <div className='input_field_section medium'>
        <input id='txt_min_cost' onChange={(d) => setMinCost(d.target.value)} type='number' value={minimum_cost}></input>
    </div>
    </div>

    let numberOfusesSec = <div className='input_section'>
    <div className='input_label_section'>
        <label>Number of uses</label>
    </div>
    <div className='input_field_section medium'>
        <input id='txt_num_use' onChange={(d) => setNumberOfUses(d.target.value)} type='number' value={number_of_uses}></input>
    </div>
    </div>

    let expireSec = <div className='input_section'>
    <div className='input_label_section'>
        <label>Expires</label>
    </div>
    <div className='input_field_section medium'>
        <YMDPicker id='sel_expire' key='sel_expire' initalValue={expire} future_years={5} onChange={(value) => change_expire(value)}></YMDPicker> 
    </div>
    </div>

    let depFromTo = <div className='input_section'>
    <div className='input_label_section'>
        <label>Departure Date From / To </label>
    </div>
    <div className='input_field_section medium'>
        <YMDPicker id='sel_dep_from' key='sel_dep_from' initalValue={departure_from} future_years={5} onChange={(value) => change_dep_from(value)}></YMDPicker>
        <div>To</div>
        <YMDPicker id='sel_dep_to' key='sel_dep_to' initalValue={departure_to} future_years={5} onChange={(value) => change_dep_to(value)}></YMDPicker> 
    </div>
    </div>

    let cookieSec = <div className='input_section'>
          <div className='input_label_section'>
            <label>Cookie Verfication</label>
        </div>
        <div className='input_field_section'>
            <input id='txt_cookie_verificaiton' onChange={(d) => setCookieVerification(d.target.value)} value={cookie_verification}></input>
        </div>
    </div>



    let btn = <div className='btn_section'>
        <button onClick={() => {addupdate_discount()}}>{btnLbl}</button>
    </div>



    return(<div className='input_form'>
        {pAgentSec}
        {codeSec}
        {pTypeSec}
        {amt}
        {expireSec}
        {depFromTo}
        {minCostSec}
        {numberOfusesSec}
        {cookieSec}
        {btn}
    </div>);


};

export default OfferAdd
